import Table, { ColumnProps } from 'antd/lib/table';
import { ROAD_TO_REWARDS_GLOSSARY } from './glossary';
import type { GlossaryEntry } from './glossary';
import style from './glossary-table.module.scss';

const COLUMNS: ColumnProps<GlossaryEntry>[] = [
    { title: 'KPI Name', dataIndex: 'kpi', key: 'kpi', width: 240 },
    { title: 'Glossary', dataIndex: 'definition', key: 'definition' },
];

/** The Glossary tab: a title over one row per KPI, name beside its definition. */
export const GlossaryTable = () => (
    <section className={style.glossary}>
        <h2 className={style.title}>Glossary</h2>
        <Table<GlossaryEntry>
            className={style.table}
            tableLayout="fixed"
            rowKey="kpi"
            dataSource={ROAD_TO_REWARDS_GLOSSARY}
            columns={COLUMNS}
            pagination={false}
        />
    </section>
);
